import React from 'react';
import PropTypes from 'prop-types';

import {Box} from 'views/components';
import {SearchRounded} from 'views/icons';
import {translate} from 'views/module';

const Search = (props) => {
  const {
    selection,
    filterOptions,
    updateFilter,
  } = props;

  const searchFilter = filterOptions?.searchString;
  const selectedSearchValue = selection?.filter?.searchString?.optionSelected ?? '';

  const [isExpanded, setIsExpanded] = React.useState(Boolean(selectedSearchValue));
  const [searchText, setSearchText] = React.useState(selectedSearchValue);

  React.useEffect(() => {
    setSearchText(selectedSearchValue);

    if (selectedSearchValue) {
      setIsExpanded(true);
    }
  }, [selectedSearchValue]);

  if (!searchFilter) {
    return null;
  }

  const handleChange = (event) => {
    const value = event.target.value;

    setSearchText(value);

    if (value.trim()) {
      updateFilter(searchFilter, {
        key: value,
        label: value,
      });
    } else {
      updateFilter(searchFilter, null);
    }
  };

  const handleBlur = () => {
    if (!searchText.trim()) {
      setIsExpanded(false);
    }
  };

  return (
    <Box
      onClick={() => setIsExpanded(true)}
      sx={{
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        width: isExpanded ? '246px' : '39px',
        height: '24px',
        px: '9px',
        borderRadius: '20px',
        backgroundColor: '#F0F0F0',
        transition: 'width 0.2s ease',
        cursor: 'text',
        overflow: 'hidden',
        flexShrink: 0,
      }}
    >
      <SearchRounded
        sx={{
          fontSize: '16px',
          color: '#7C7C7C',
          flexShrink: 0,
        }}
      />
      {
        isExpanded &&
        <Box
          component='input'
          autoFocus
          value={searchText}
          placeholder={translate('clientLead.ClientLeadList.Filter.SearchPlaceholder')}
          onChange={handleChange}
          onBlur={handleBlur}
          sx={{
            'width': '100%',
            'minWidth': 0,
            'p': 0,
            'border': 'none',
            'outline': 'none',
            'backgroundColor': 'transparent',
            'fontFamily': 'Geist Mono',
            'fontStyle': 'normal',
            'fontWeight': 400,
            'fontSize': '11px',
            'lineHeight': '14px',
            'color': '#6B6760',
            '&::placeholder': {
              'color': '#7C7C7C',
              'opacity': 1,
            },
          }}
        />
      }
    </Box>
  );
};

Search.propTypes = {
  selection: PropTypes.object.isRequired,
  filterOptions: PropTypes.object.isRequired,
  updateFilter: PropTypes.func.isRequired,
};

export default React.memo(Search);
